import {
  CostCodeCreate,
  CostCodeOrderRequest,
  CostCodePatch,
  JobCostCodeSchema,
  JobCreate,
  JobPatch,
  JobResponse,
  ReconcileRequest,
  SetForemenRequest,
} from '@siteday/shared';
import { type z } from 'zod';

import { api } from './client';
import { listOf } from './list';

export type JobsFilters = { status?: string | undefined; search?: string | undefined };

export const listJobs = (filters: JobsFilters = {}) =>
  api.get('/jobs', listOf(JobResponse), { status: filters.status, search: filters.search });

export const getJob = (id: string) => api.get(`/jobs/${id}`, JobResponse);

export const createJob = (input: z.input<typeof JobCreate>) =>
  api.post('/jobs', JobCreate.parse(input), JobResponse);

export const patchJob = (id: string, patch: z.input<typeof JobPatch>) =>
  api.patch(`/jobs/${id}`, JobPatch.parse(patch), JobResponse);

export const setForemen = (id: string, userIds: string[]) =>
  api.put(`/jobs/${id}/foremen`, SetForemenRequest.parse({ userIds }), JobResponse);

export const reconcileJob = (id: string, intoJobId: string) =>
  api.post(`/jobs/${id}/reconcile`, ReconcileRequest.parse({ intoJobId }), JobResponse);

// ---- cost codes (doc 05 Cost codes) ----
export const listCostCodes = (jobId: string) =>
  api.get(`/jobs/${jobId}/cost-codes`, listOf(JobCostCodeSchema));

export const createCostCode = (jobId: string, input: z.input<typeof CostCodeCreate>) =>
  api.post(`/jobs/${jobId}/cost-codes`, CostCodeCreate.parse(input), JobCostCodeSchema);

export const patchCostCode = (jobId: string, id: string, patch: z.input<typeof CostCodePatch>) =>
  api.patch(`/jobs/${jobId}/cost-codes/${id}`, CostCodePatch.parse(patch), JobCostCodeSchema);

export const archiveCostCode = (jobId: string, id: string) =>
  api.post(`/jobs/${jobId}/cost-codes/${id}/archive`, undefined, JobCostCodeSchema);

export const copyCostCodesFrom = (jobId: string, otherJobId: string) =>
  api.post(
    `/jobs/${jobId}/cost-codes/copy-from/${otherJobId}`,
    undefined,
    listOf(JobCostCodeSchema),
  );

export const orderCostCodes = (jobId: string, ids: string[]) =>
  api.put(
    `/jobs/${jobId}/cost-codes/order`,
    CostCodeOrderRequest.parse({ ids }),
    listOf(JobCostCodeSchema),
  );
